import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const UNITOFMEASURE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.UnitOfMeasure.Name')
    .minLength(1)
    .maxLength(20)
    .required()
    .build(),
  FieldBuilder
    .text('code', 'Entity.UnitOfMeasure.Code')
    .minLength(1)
    .maxLength(10)
    .required()
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.UnitOfMeasure.SapCode')
    .minLength(1)
    .maxLength(10)
    .required()
    .build(),
  FieldBuilder
    .text('iso', 'Entity.UnitOfMeasure.Iso')
    .maxLength(3)
    .build(),
];

export const UNITOFMEASURE_CONFIG = {
  entityName: 'UnitOfMeasure',
  localizationKey: 'General::Entity.UnitOfMeasure',
  fields: UNITOFMEASURE_FIELDS,
  permission: 'ControllingLiquidations.UnitOfMeasures',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
